// import capitalize from 'lodash/capitalize';
import forEach from 'lodash/forEach';
// import isEmpty from 'lodash/isEmpty';
// import sortBy from 'lodash/sortBy';

import axios from 'axios';
import settings from './settings';
import {decode} from 'html-entities';
import taskTypes from './enums/taskTypes';
import memoize from "lodash/memoize";

export default new class UtilsService {
    constructor() {
        // this.$filter = $filter;
        // this.http = $http;
        // this.$q = $q;
        // this.settings = Settings;
        //this.toastService = ToastService;
    }

    areWeTestingWithJest() {
      return process.env.JEST_WORKER_ID !== undefined;
    }

    // decodeHtml for html symbols
    decodeHtml(input) {
      // Entities decode can't decode &nbsp; for some reason
      return decode(input).replace(/&nbsp;/gi, ' ');
    }

    getLegitJsonFromArrays(arrayOfArrays) {
        // sometimes api returns array of arrays
        // in which index 0 contains the name
        // and index 1 contains the value.
        // here we turn it into JSON

        let legitJson = {};
        arrayOfArrays.forEach( subArray => {
            legitJson[subArray[0]] = subArray[1];
        });

        return legitJson;
    }

    getArraysFromLegitJson(legitJson) {
        // transform JSON to array of arrays, which is the input format for many api calls

        let arrayOfArrays = [];

        for (let key in legitJson)
            if (
                legitJson.hasOwnProperty(key) &&
                typeof legitJson[key] !== 'undefined'
            )
                arrayOfArrays.push([key, legitJson[key]]);

        return arrayOfArrays;
    }

    clone(obj) {
        if (null == obj || "object" != typeof obj) return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
      }

    // // first letter is capital, rest are lowercase
    // capitalize(inputString) {
    //     // return inputString[0].toUpperCase() + inputString.substring(1).toLowerCase();

    //     // lodash wasn't doing it right until v4.0, hence the need for util func pre 4.0
    //     return capitalize(inputString);
    // }

    // capitalizeMulti(inputString) {
    //     return inputString
    //         .replace(/^\w|\s(\w)/g, match => {
    //             return match.toUpperCase();
    //         })
    //         .trim();
    // }

    // convertToFriendlyDate(dateString) {
    //     // let utc = Number(dateString.match(/\d+/i)[0]);
    //     // let formatDate = new Date(utc);
    //     // return formatDate.toLocaleString();

    //     return this.$filter('intDate')(dateString);
    // }

    convertToTaskTypesJson(trickArray) {
        let taskTypes = [];

        if (trickArray.length) {
            forEach(trickArray, tasktype => {
                //use int7 names, instead of extJS names for UI
                let name = tasktype.name;
                if (name === 'Form') {
                    name = 'Legacy Form';
                } else if (name === 'Power Form') {
                    name = 'Form';
                }

                taskTypes.push({
                    sid: tasktype.sid,
                    name: name,
                    group:
                        tasktype.group === 'Standard' ? 'Standard' : 'Plugin',
                    imagePath: tasktype.image_path,
                });
            });
        }
        return taskTypes;
    }

    // findAncestorTag(el, tagname) {
    //     // use this helper function to traverse an elements DOM ancestors
    //     // to find the first occurrence of a tag named tagname
    //     if (el)
    //         while ((el = el.parentElement) && el.tagName !== tagname.toUpperCase());
    //     return el;
    // }

    // isSystemObject(sid) {
    //     return sid.toUpperCase() === 'BB6CB26B-D179-4763-B2CB-69D107DFD1D8';
    // }



    // getAriaSortFunction(scope) {
    //     let localScope = scope;

    //     return column => {
    //         if (localScope.predicate === column) {
    //             if (!localScope.reverse) return 'ascending';
    //             return 'descending';
    //         }
    //         return 'none';
    //     };
    // }

    // getChoicesFromArrayOfArrays(arrays) {
    //     let choices = [];
    //     angular.forEach(arrays, subArray => {
    //         choices.push({
    //             Value: subArray[0],
    //             Label: subArray[1],
    //         });
    //     });
    //     return choices;
    // }

    // getLocales() {
    //     return this.http
    //         .get(`${this.settings.wcfRoot}/utilities/locales/script/`, {
    //             cache: true,
    //         })
    //         .then(response => {
    //             // convert array of arrays to JSON
    //             let locales = [];

    //             let USLocale;

    //             response.data.forEach(localeArray => {
    //                 //place US locale on top of locale list
    //                 if (localeArray[1] === 'English (United States)') {
    //                     USLocale = {
    //                         id: localeArray[0],
    //                         name: localeArray[1],
    //                     };
    //                 } else {
    //                     locales.push({
    //                         id: localeArray[0],
    //                         name: localeArray[1],
    //                     });
    //                 }
    //             });

    //             locales = sortBy(locales, locale => {
    //                 return locale.name;
    //             });

    //             locales.unshift(USLocale);

    //             return locales;
    //         });
    // }

    // getObjectTypePlural(objectType) {
    //     if (objectType === 'process') return 'processes';
    //     if (objectType === 'category') return 'categories';
    //     if (objectType === 'powerform') return 'powerform';

    //     return objectType + 's';
    // }

    // getParentKeyValueJsonFromArrays(arrayOfArrays) {
    //     // sometimes api returns an array of arrays
    //     // ex:
    //     /*
    //     [
    //      [
    //      "portal",
    //      "portlet-myreport_run-swp65",
    //      "{\"dataParams\":{\"report_sid\":\"ca391e3d-b5e0-4b9d-90f3-2b6a12f9cb37\",\"start\":0,\"limit\":10,\"filters\":\"null\"},\"title\":\"My Report - SolarWinds Contract Review\"}"
    //      ],...
    //      ]
    //      */
    //     // here we convert it to:
    //     /*
    //     [{
    //         ParentKey: "portal",
    //         Key: "portlet-myreport_run-swp65",
    //         Value: "<JSON parsed value>"
    //     },...
    //     ]
    //      */
    //     let legitJsonArray = [];
    //     forEach(arrayOfArrays, subArray => {
    //         let legitJson = {
    //             ParentKey: subArray[0],
    //             Key: subArray[1],
    //         };

    //         // sometimes the value isn't JSON...
    //         try {
    //             legitJson.Value = angular.fromJson(subArray[2]); //JSON.parse(subArray[2]);
    //         } catch (e) {
    //             legitJson.Value = subArray[2];
    //         }

    //         legitJson.Value2 = subArray[3];
    //         legitJson.Value3 = subArray[4];

    //         legitJsonArray.push(legitJson);
    //     });

    //     return legitJsonArray;
    // }

    // // $scope.predicate and $scope.reverse should be defined in calling controller
    // // before calling this
    // getSortFunction(scope) {
    //     let localScope = scope;

    //     return predicate => {
    //         localScope.reverse =
    //             localScope.predicate === predicate
    //                 ? !localScope.reverse
    //                 : false;
    //         localScope.predicate = predicate;
    //     };
    // }

    async getTaskTypes() {
      if (!this.taskTypes){
        const response = await axios.get(`${settings.nodeRoot}/tasks/types`)
        this.taskTypes = this.convertToTaskTypesJson(response.data);
      }
      return this.taskTypes;
    }

    getTimeStamp() {
        return axios.get('/timestamp.json').then(res => res.data);
    }

    getImageJson() {
        try {
            // written by git_dump.sh
            return require('../../../imageinfo.json');
        } catch (error) {
            if (error?.code === "MODULE_NOT_FOUND") {
                // imageinfo.json is not available for local build, it's fine
            } else {
                console.error('getImageJson', error);
            }
            return {};
        }
    }

    filterDuplicateTaskNames(processTasks) {

        if(!processTasks) return

        let processTasksCopy = JSON.parse(JSON.stringify(processTasks));

        for (const [index, pt] of processTasks.entries()) {
            if (processTasks.some(t => (t.taskName == pt.taskName) &&
                (t.processTaskId !== pt.processTaskId))) {
                processTasksCopy[index].taskName = `${pt.taskName} (${pt.processTaskId})`;
            }
        }
        return processTasksCopy;

    }

    /* 9.13.2023 MD: Util function for dercerning a tasks' type in the event that information is not present but the type GUID is.
                     validate on use incase GUID was not present. Ensure incoming GUID is lowercase. Initally for #2313 */              
    getTaskTypeFromTypeGuid(incomingGuid) 
    {;
        for (const taskType in taskTypes) {
            if (taskTypes[taskType].guid === incomingGuid.toLowerCase()) {
                return taskTypes[taskType].name;
            }
        }
        return null;
    }

    // getTimeZones() {
    //     return this.http
    //         .get(`${this.settings.wcfRoot}/utilities/timezone/script/`, {
    //             cache: true,
    //         }).then(res => res.data);
    // }

    // mobileCheck() {
    //     let check = false;
    //     (function(a) {
    //         if (
    //             /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    //                 a
    //             ) ||
    //             /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    //                 a.substr(0, 4)
    //             )
    //         )
    //             check = true;
    //     })(navigator.userAgent || navigator.vendor || window.opera);
    //     return check;
    // }

    // properCase(inputString) {
    //     let lInput = inputString.toLowerCase();
    //     if (lInput === 'powerform') {
    //         return 'PowerForm';
    //     } else if (lInput === 'emailmonitor') {
    //         //CamelCase
    //         return 'EmailMonitor';
    //     } else if (lInput === 'databaseconnection') {
    //         return 'DatabaseConnection';
    //     } else if (lInput === 'biztime') {
    //         return 'BizTime';
    //     } else {
    //         return (
    //             inputString[0].toUpperCase() +
    //             inputString.substring(1).toLowerCase()
    //         );
    //     } //capitalize
    // }

    // setFriendlyResultSetJson(meanResultSetJson) {
    //     // data input for the grids that comes out of the backend contain an array with
    //     // the first row containing column info and the rest of the rows in plain arrays (no properties)

    //     // this method uses the first row to build the template for a json object and returns an array
    //     // of friendly named json objects containing the original data

    //     if (!isEmpty(meanResultSetJson.Items)) {
    //         let columnHeaders = meanResultSetJson.Items[0];
    //         let friendlyItems = [];

    //         forEach(meanResultSetJson.Items, meanItem => {
    //             let friendlyItem = {};

    //             forEach(columnHeaders, (columnHeader, index) => {
    //                 friendlyItem[columnHeader] = meanItem[index];
    //             });

    //             friendlyItems.push(friendlyItem);
    //         });

    //         if (friendlyItems.length > 0) friendlyItems.shift(); // get rid of that first row that contains the column headers

    //         meanResultSetJson.FriendlyItems = friendlyItems;
    //     }
    // }

    // showToast(text, toastPosition, hideDelay) {
    //     this.toastService.showToast(text, toastPosition, hideDelay);
    // }

    // sortByTableIndex(array) {
    //     return sortBy(array, [
    //         function(row) {
    //             return row.index;
    //         },
    //     ]);
    // }

    isInIFRAME() {
        return window.self !== window.top;
    }

    /**
     * Wraps fn to cache generated value in localstorage and in memory.
     */
    memoizeLocalStorage(key, fn) {
        return memoize(function memoizedLocalStorage() {
            let val = localStorage.getItem(key);
            if (val == null || val === '') {
                val = fn();
                localStorage.setItem(key, val);
            }
            return val;
        });
    }

    getDeviceInfo() {
        return {
            OS: "",
            browser: "",
        };
    }

    composeNavGuards(...navGuards) {
        const promisifyNavGuard = (navGuard) => (to, from) => new Promise(resolve => navGuard(to, from, resolve));
        navGuards = navGuards.map(promisifyNavGuard);

        return async function composedNavGuards(to, from, next) {
            for (const navGuard of navGuards) {
                const result = await navGuard(to, from);
                if (result == false) {
                    next(result);
                    return;
                }
            }

            next();
            return;
        }
    }

    onStyleAddedById(id, handler, { once = false } = {}) {
        {
            const el = document.getElementById(id);
            if (el) {
                handler(el);
                if (once) return;
            }
        }
      
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList' && mutation.addedNodes) {
                    for (const node of mutation.addedNodes) {
                        if (node.id === id) {
                            if (once) {
                                observer.disconnect();
                            }

                            handler(node);
                            return;
                        }
                    }
                }
            }
        });
      
        observer.observe(document.head, {
            childList: true,
        });

        return observer;
    }

    onStyleChanged(el, handler) {
        const observer = new MutationObserver((mutations) => {
            handler();
        });
      
        observer.observe(el, {
            childList: true,
            attributes: true,
            characterData: true,
        });

        return observer;
    }

    getPrevUrl() {
        const recentlyVisited = JSON.parse(localStorage.getItem('recently-visited'));
        const previousUrl = recentlyVisited?.[0]?.href ?? null;
        if (previousUrl && previousUrl !== window.location.href) return previousUrl;
        return '/';
    }
}
